import Button from './Button';
import Modal from './Modal';

const ConfirmDialog = ({
  open,
  title = 'Confirmar accion',
  message,
  confirmLabel = 'Confirmar',
  loading = false,
  onConfirm,
  onCancel
}) => {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onCancel}
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onCancel} disabled={loading}>
            Cancelar
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={loading}>
            {loading ? 'Procesando...' : confirmLabel}
          </Button>
        </div>
      }
    >
      <p className="text-sm text-gray-600">{message}</p>
    </Modal>
  );
};

export default ConfirmDialog;
